import {Dayjs} from "dayjs";

class ControlHorari {
    constructor(
        public key = 0,
        public id = 0,
        public id_usuario = 0,
        public nom = "",
        public entrada: string | Dayjs = "",
        public sortida: string | Dayjs = "",
        public estat = 0,
        public id_lloc = 0,
        public lloc = "",
    ) {
        this.key = key;
        this.id = id;
        this.id_usuario = id_usuario;
        this.nom = nom;
        this.entrada = entrada;
        this.sortida = sortida;
        this.estat = estat;
        this.id_lloc = id_lloc;
        this.lloc = lloc;
    }
}

export default ControlHorari;
